import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f3ca810"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full overflow-y-auto content-box max-w-14xl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "撰写点评", -1))
const _hoisted_3 = { class: "lecture-title" }
const _hoisted_4 = { class: "text-gray-600" }
const _hoisted_5 = { class: "star-box" }
const _hoisted_6 = { class: "star-box__item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600" }, "难易程度", -1))
const _hoisted_8 = { class: "star-box__item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600" }, "给分好坏", -1))
const _hoisted_10 = { class: "star-box__item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600" }, "工作量", -1))
const _hoisted_12 = { class: "star-box__item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600" }, "综合推荐指数", -1))
const _hoisted_14 = { class: "textarea-box" }
const _hoisted_15 = { class: "action-box" }
const _hoisted_16 = { class: "action-box__left" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 清 空 ")
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "action-box__right flex flex-wrap" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 恢复草稿 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 保 存 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 发 布 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rating_head_bar = _resolveComponent("rating-head-bar")!
  const _component_five_stars = _resolveComponent("five-stars")!
  const _component_f_button = _resolveComponent("f-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_rating_head_bar, {
      "is-back-visible": "",
      onClickBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routerBack(`/rating/lecture/${_ctx.lectureId}`)))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.lectureName), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_five_stars, {
          modelValue: _ctx.formData.difficulty,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.difficulty) = $event)),
          clickable: "",
          hint: _ctx.scoreTextTable.difficulty,
          size: 26,
          spacing: 6
        }, null, 8, ["modelValue", "hint"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_five_stars, {
          modelValue: _ctx.formData.nice,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.nice) = $event)),
          clickable: "",
          hint: _ctx.scoreTextTable.nice,
          size: 26,
          spacing: 6
        }, null, 8, ["modelValue", "hint"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_five_stars, {
          modelValue: _ctx.formData.workload,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.workload) = $event)),
          clickable: "",
          hint: _ctx.scoreTextTable.workload,
          size: 26,
          spacing: 6
        }, null, 8, ["modelValue", "hint"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_five_stars, {
          modelValue: _ctx.formData.recommended,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.recommended) = $event)),
          clickable: "",
          hint: _ctx.scoreTextTable.recommended,
          size: 26,
          spacing: 6
        }, null, 8, ["modelValue", "hint"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.content) = $event)),
        class: "text-gray-600",
        placeholder: "请输入具体点评内容",
        maxlength: "5000"
      }, null, 512), [
        [_vModelText, _ctx.formData.content]
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("span", _hoisted_16, [
        _createVNode(_component_f_button, {
          class: "button-gray text-gray-600",
          shape: "circle",
          size: "large",
          onClick: _ctx.handleClickReset
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("span", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, [
          _createVNode(_component_f_button, {
            shape: "circle",
            size: "large",
            loading: _ctx.isLoading,
            onClick: _ctx.handleClickGetDraft
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["loading", "onClick"]),
          _createVNode(_component_f_button, {
            class: _normalizeClass({ 'button-gray text-gray-600': _ctx.isRateDraftEdited }),
            shape: "circle",
            size: "large",
            disabled: !_ctx.isRateDraftEdited,
            loading: _ctx.isLoading,
            onClick: _ctx.handleClickSaveDraft
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }, 8, ["class", "disabled", "loading", "onClick"]),
          _createVNode(_component_f_button, {
            shape: "circle",
            type: "primary",
            size: "large",
            disabled: !_ctx.isFormDataAvailable || !_ctx.isRateEdited,
            loading: _ctx.isLoading,
            onClick: _ctx.handleClickSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["disabled", "loading", "onClick"])
        ])
      ])
    ])
  ]))
}